import { of } from 'rxjs';
import { mergeAll } from 'rxjs/operators';

// TODO(steckel): Move to RxJS utilities?
const foldOperators = pipes => source => of(...pipes.map(pipe => source.pipe(pipe)));

// Combine multiple analytics signals into one.
const analytics = pipes => source => source.pipe(foldOperators(pipes), mergeAll());
export default analytics;